import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("../views/Frame.vue"),

    children: [
      {
        path: "",
        name: "Index",
        component: () => import("../views/dashboards/AdminDashboard.vue"),
      },

      {
        path: "clazz-dashboard",
        name: "ClazzDashboard",
        component: () => import("../views/dashboards/ClazzDashboard.vue"),
      },

      {
        path: "common-books",
        component: { template: "<router-view/>" },
        children: [
          {
            path: "",
            name: "CommonBookList",
            component: () =>
              import("../views/books/commonBooks/CommonBookList.vue"),
          },
          {
            path: "edit",
            name: "CommonBookEdit",
            component: () =>
              import("../views/books/commonBooks/CommonBookEdit.vue"),
          },
        ],
      },

      {
        path: "optional-books",
        component: { template: "<router-view/>" },
        children: [
          {
            path: "",
            name: "OptionalBookList",
            component: () =>
              import("../views/books/optionalBooks/OptionalBookList.vue"),
          },
          {
            path: "revise/:id",
            name: "OptionalBookRevise",
            component: () =>
              import("../views/books/optionalBooks/OptionalBookRevise.vue"),
          },
        ],
      },

      {
        path: "exam-records",
        component: { template: "<router-view/>" },
        children: [
          {
            path: "",
            name: "ExamRecordList",
            component: () => import("../views/examRecords/ExamRecordList.vue"),
          },
          {
            path: "edit",
            name: "ExamRecordEdit",
            component: () => import("../views/examRecords/ExamRecordEdit.vue"),
          },
          {
            path: "stat/by/book",
            name: "StatExamRecordByBook",
            component: () => import("../views/examRecords/CommonBookList.vue"),
          },
          {
            path: "batch-assess/book/:bookId",
            name: "BatchAssess",
            component: () => import("../views/examRecords/BatchAssess.vue"),
          },
        ],
      },

      {
        path: "daily-records",
        component: { template: "<router-view/>" },
        children: [
          {
            path: "",
            name: "DailyRecordList",
            component: () =>
              import("../views/dailyRecords/DailyRecordList.vue"),
          },
        ],
      },

      {
        path: "student-grades",
        component: { template: "<router-view/>" },
        children: [
          {
            path: "best-grades",
            name: "ClazzBestGrades",
            component: () => import("../views/studentGrades/BestGrades.vue"),
          },
        ],
      },

      {
        path: "stats",
        component: { template: "<router-view/>" },
        children: [
          {
            path: "record/by/grade",
            name: "StatPeriodRecordByGrade",
            component: () =>
              import("../views/stats/StatPeriodRecordByGrade.vue"),
          },
          {
            path: "grade-year/:gradeYear/record/by/clazz",
            name: "StatPeriodRecordByClazz",
            component: () =>
              import("../views/stats/StatPeriodRecordByClazz.vue"),
          },
          {
            path: "clazz/:clazzId/record/by/student",
            name: "StatPeriodRecordByStudent",
            component: () =>
              import("../views/stats/StatPeriodRecordByStudent.vue"),
          },

          {
            path: "read-grade/by/grade",
            name: "StatReadGradeByGrade",
            component: () => import("../views/stats/StatReadGradeByGrade"),
          },
          {
            path: "grade-year/:gradeYear/read-grade/by/clazz",
            name: "StatReadGradeByClazz",
            component: () => import("../views/stats/StatReadGradeByClazz.vue"),
          },
          {
            path: "record/by/grade-year-book-type",
            name: "StatRecordByGrade",
            component: () => import("../views/stats/StatRecordByGrade.vue"),
          },
          {
            path: "grade-year/:gradeYear/record/by/clazz-book-type",
            name: "StatRecordByClazz",
            component: () => import("../views/stats/StatRecordByClazz.vue"),
          },
          {
            path: "clazz/:clazzId/record/by/student-book-type",
            name: "StatRecordByStudent",
            component: () => import("../views/stats/StatRecordByStudent.vue"),
          },

          {
            path: "sign-rate/by/grade",
            name: "StatSignRateByGrade",
            component: () => import("../views/stats/StatSignRateByGrade.vue"),
          },

          {
            path: "sign-rate/by/clazz/grade-year/:gradeYear",
            name: "StatSignRateByClazz",
            component: () => import("../views/stats/StatSignRateByClazz.vue"),
          },

          {
            path: "sign-rate/by/stduent/clazz/:clazzId",
            name: "StatSignRateByStudent",
            component: () => import("../views/stats/StatSignRateByStudent.vue"),
          },

          {
            path: "clazz-student-reports/clazz/:clazzId",
            name: "ClazzStudentReportList",
            component: () =>
              import("../views/stats/ClazzStudentReportList.vue"),
          },
        ],
      },

      {
        path: "reading-progresses",
        component: { template: "<router-view/>" },
        children: [
          {
            path: "todo",
            name: "TodoReadingProgressList",
            component: () => import("../views/readingProgresses/TodoList.vue"),
          },
        ],
      },

      {
        path: "config",
        component: { template: "<router-view/>" },
        children: [
          {
            path: "quality-percent",
            name: "QualityPercentConfig",
            component: () => import("../views/config/QualityPercent.vue"),
          },
          {
            path: "data-sync",
            name: "DataSync",
            component: () => import("../views/config/DataSync.vue"),
          },
        ],
      },

      {
        path: "users",
        component: { template: "<router-view/>" },
        children: [
          {
            path: "",
            name: "UserList",
            component: () => import("../views/users/UserList.vue"),
          },
          {
            path: "edit",
            name: "UserEdit",
            component: () => import("../views/users/UserEdit.vue"),
          },
          {
            path: "profile",
            name: "Profile",
            component: () => import("../views/users/Profile.vue"),
          },
          {
            path: "change-password",
            name: "ChangePassword",
            component: () => import("../views/users/ChangePassword.vue"),
          },
          {
            path: "import",
            name: "UserImport",
            component: () => import("../views/users/UserImport.vue"),
          },
        ],
      },

      {
        path: "teacher-duties",
        component: { template: "<router-view/>" },
        children: [
          {
            path: "",
            name: "TeacherDutyList",
            component: () =>
              import("../views/teacherDuties/TeacherDutyList.vue"),
          },
        ],
      },

      {
        path: "students",
        name: "StudentList",
        component: () => import("../views/students/StudentList.vue"),
      },

      {
        path: "students/term-year/:termYear/clazz/:clazzId/read-grade/:readGrade",
        name: "ClazzReadGradeStudentList",
        component: () => import("../views/stats/ReadGradeStudentList.vue"),
      },

      {
        path: "students/term-year/:termYear/grade-year/:year/read-grade/:readGrade",
        name: "GradeReadGradeStudentList",
        component: () => import("../views/stats/ReadGradeStudentList.vue"),
      },

      {
        path: "clazzes",
        name: "ClazzList",
        component: () => import("../views/clazzes/ClazzList.vue"),
      },

      {
        path: "choose-duty",
        name: "ChooseDuty",
        component: () => import("../views/ChooseDuty.vue"),
      },
    ],
  },

  {
    path: "/login",
    name: "Login",
    component: () => import("../views/LoginView.vue"),
  },

  {
    path: "/recommend/:studentId",
    name: "Recommend",
    component: () => import("../views/ai/RecommendForStudent.vue"),
  },

  {
    path: "/analysis/:clazzId",
    name: "Analysis",
    component: () => import("../views/ai/AnalysisForTeacher.vue"),
  },

  {
    path: "/pdf/test",
    name: "PDFTest",
    component: () => import("../views/pdftest/index.vue"),
  },

  {
    path: "/pdf/test1",
    name: "PDFTest1",
    component: () => import("../views/pdftest/index.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  document.title = "春晖青葵阅读";

  const PUBLIC_ROUTE_NAMES = [
    "Login",
    "Recommend",
    "Analysis",
    "PDFTest",
    "PDFTest1",
  ];

  /**除登录页外，都验证认证状态 */
  if (!PUBLIC_ROUTE_NAMES.includes(to.name) && !store.state.token) {
    return next({
      name: "Login",
    });
  }

  next();
});

export default router;
